/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Onboarding_You_TitleInputs */

const en_ui_onboarding_you_title = /** @type {(inputs: Ui_Onboarding_You_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You and your heart rate`)
};

const de_ui_onboarding_you_title = /** @type {(inputs: Ui_Onboarding_You_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du und deine Herzfrequenz`)
};

/**
* | output |
* | --- |
* | "You and your heart rate" |
*
* @param {Ui_Onboarding_You_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_onboarding_you_title = /** @type {((inputs?: Ui_Onboarding_You_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Onboarding_You_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_onboarding_you_title(inputs)
	return de_ui_onboarding_you_title(inputs)
});